export const schoolList = () => require.ensure([], () => require("./list/schoolList.vue"), "schoolList");